import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
    IAgentClientState,
    IAgentStateTransitionRequested,
    IMessage
} from '../../models/BlenderAgentStateModel';
import { AppThunk, RootState } from '../store';

export interface Method {
    name: string;
    handler(data: unknown): void;
}

export interface IHandlers {
    onGettingStatus(agentClientStatate: IAgentClientState): void;
    onStateTransitions(agentStateTranistion: IAgentStateTransitionRequested): void;
}

export interface IBlenderHub {
    start(): Promise<unknown>;
}
        
export interface IBlenderState {
    connectionStatus: string,
    agentClientState: IAgentClientState,
    agentStateTransitionRequested: IAgentStateTransitionRequested,
    message: IMessage,
    workItemsCount: number,
}

const initialState: IBlenderState = {
    connectionStatus: '',
    agentClientState: {
        agentProperties: {
            id: '',
            state: 'Break',
            stateSince: '',
            breakName: '',
            capabilities: [],
            displaySettings: {
                hideExternalContacts: false,
                hideSensitiveAgentInformation: false,
            },
        },
        workItems: {},
        timeStamp: {
            timeStamp: ''
        },
    },    
    agentStateTransitionRequested: {
        toState: '',
        initiatedBy: ''
    },
    message: {
        id: 0,
        timeStamp: '',
        text: '',
        link: ''
    },
    workItemsCount: 0
}

const consumeBlenderHubSlice = createSlice({
    initialState,
    name: 'blenderHub',
    reducers: {
        setConnectionStatus: (state, action:PayloadAction<string>) => {
            state.connectionStatus = action.payload;
        },
        setAgentClientState: (state, action: PayloadAction<IAgentClientState>) => {
            state.agentClientState = action.payload;
            state.workItemsCount = Object.keys(state.agentClientState.workItems).length;
        },
        setAgentStateTransitioned: (state, action: PayloadAction<IAgentStateTransitionRequested>) => {
            state.agentStateTransitionRequested = action.payload;
        },
        setMessageState: (state, action: PayloadAction<IMessage>) => {
            state.message = action.payload;
        },
    },
});

const {
    setConnectionStatus,
    setAgentClientState,
    setAgentStateTransitioned,
    setMessageState
} = consumeBlenderHubSlice.actions;

export const updateConnectionStatus =
    (status: string): AppThunk =>
    async (dispatch) => {
        dispatch(setConnectionStatus(status));
};

export const updateStateDataRetrieved =
    (agentClientState: IAgentClientState): AppThunk =>
        async (dispatch) => {
            dispatch(setAgentClientState(agentClientState));
};

export const updateAgentStateTransitioned =
    (agentClientStateTransitioned: IAgentStateTransitionRequested): AppThunk =>
        async (dispatch) => {
            dispatch(setAgentStateTransitioned(agentClientStateTransitioned));
};

export const updateMessageState =
    (message: IMessage): AppThunk =>
        async (dispatch) => {
            dispatch(setMessageState(message));
};

export const selectBlenderHub = (state: RootState) =>
    state.blenderState;

export default consumeBlenderHubSlice.reducer;